import React from "react";
import DataGrid, { Column, HeaderFilter, Paging, Pager } from "devextreme-react/ui/data-grid";
import validaciones from "../../../../../../helpers/validaciones";

class TablaPeriodosReposo extends React.PureComponent {
  render() {
    return (
      <DataGrid
        className="custom-table height-min cursor-disabled"
        showBorders={false}
        showColumnLines={false}
        renderAsync
        showRowLines={false}
        noDataText=""
        rowAlternationEnabled
        dataSource={this.props.data}
        onContentReady={(e) => {
          if (e.component.totalCount() === 0) {
            const config = {};
            config.addClass = "table-margin";
            const noDataSpan = e.component.element().querySelector(".dx-datagrid-nodata");
            const element = validaciones.noDataDOMElement(config, "Sin períodos de reposo");
            noDataSpan.appendChild(element);
          }
        }}
      >
        <HeaderFilter
          visible
          texts={{
            cancel: "Cancelar",
            emptyValue: "Sin valor",
            ok: "Aceptar",
          }}
        />
        <Column
          calculateCellValue={(data) => (data.FechaInicio && new Date(data.FechaInicio).toLocaleDateString()) || "S/D"}
          dataField="FechaInicio"
          caption="Fecha inicio"
          dataType="date"
          format="dd/MM/yyyy"
          allowFiltering={false}
        />
        <Column
          calculateCellValue={(data) => (data.FechaFin && new Date(data.FechaFin).toLocaleDateString()) || "S/D"}
          dataField="FechaFin"
          caption="Fecha fin"
          dataType="date"
          format="dd/MM/yyyy"
          allowFiltering={false}
        />
        <Column
          dataField="DiasReposo"
          calculateCellValue={(data) => data.DiasReposo || "S/D"}
          caption="Días de reposo"
          allowFiltering={false}
          alignment="center"
        />
        <Column
          dataField="TipoAlta"
          allowFiltering={false}
          calculateCellValue={(data) => data.TipoAlta && data.TipoAlta !== "null" ? data.TipoAlta : "S/D"}
        />
        <Paging pageSize={10} enabled />
        <Pager showNavigationButtons showInfo infoText={(page, total) => `Página ${page} de ${total}`} />
      </DataGrid>
    );
  }
}

export default TablaPeriodosReposo;
